import React from "react";
import PropTypes from "prop-types";
import { Link, useHistory } from "react-router-dom";

// styled components
import ErrorStyled from "./ErrorWrapper.styled";
import LoginHook from "../../../hooks/LoginHooks";

const Error = ({ errorText, errorHeading, errorLink, errorLinkText, errorCallback, externalLink, ariaLabelForLink, loginPrompt }) => {
    const { openLoginModal, openSignupModal } = LoginHook();
    const history = useHistory();
    return (
        <ErrorStyled>
            <div className="m53__container">
                <span className="m53__warning__icon warning"></span>
                <div>
                    {errorHeading && (
                        <>
                            <p className="m53__warning__text">{errorHeading}</p>
                        </>
                    )}
                    {errorText && (
                        <>
                            <p>
                                {errorText}
                                {externalLink && errorLinkText && (
                                    <>
                                        <a href={externalLink} target="_blank" rel="noopener noreferrer" aria-label={ariaLabelForLink}>
                                            {errorLinkText}
                                        </a>
                                    </>
                                )}
                            </p>
                        </>
                    )}

                    {errorLink && errorLinkText && (
                        <>
                            <button
                                type="button"
                                onClick={() => {
                                    history.push(errorLink);
                                }}
                                aria-label={ariaLabelForLink}
                            >
                                {errorLinkText}
                            </button>
                        </>
                    )}

                    {errorCallback && errorLinkText && (
                        <>
                            <Link href="/" onClick={e => errorCallback(e)}>
                                {errorLinkText}
                            </Link>
                        </>
                    )}

                    {loginPrompt && (
                        <>
                            <Link href="/" onClick={openLoginModal}>
                                Log in
                            </Link>
                            <span> or </span>
                            <Link href="/" onClick={openSignupModal}>
                                sign up
                            </Link>
                            <span> here</span>
                        </>
                    )}
                </div>
            </div>
        </ErrorStyled>
    );
};

// props validation
Error.propTypes = {
    errorText: PropTypes.string.isRequired,
    errorHeading: PropTypes.string,
    errorLink: PropTypes.string,
    errorLinkText: PropTypes.string,
    errorCallback: PropTypes.func,
    externalLink: PropTypes.string,
    ariaLabelForLink: PropTypes.string,
    loginPrompt: PropTypes.bool
};

export default Error;
